module.exports = __webpack_public_path__ + "static/media/yobm.0aebd3bd.pdf";